<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fields"
          :orderby="sortBy"
          :actions="actions"
          :optionsButton="optionsButton"
          :items="lstIsencao"
          responsive
          :porPage="itemPorPage"
          pdf
          csv
          xls
          search
          pagination
          :titlePage="titlePage"
          :titlePDF="titlePDF"
        ></fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="addFieldModal"
      size="lg"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="isencao.idsir === 0 ? addIsencaoReducao() : editIsencaoReducao()">
        <div class="borderForm">
          <div class="row innerPage">
            <div class="col-sm-4 titlePage">SIR</div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-6">
              <fccInput extraClasses="inputLabel" required v-model="isencao.instituicao" disabled
                >Instituição<span>*</span></fccInput
              >
            </div>
            <div class="col-sm-6">
              <fccInput extraClasses="inputLabel" v-model="isencao.concurso" disabled
                >Concurso<span>*</span></fccInput
              >
            </div>
          </div>

          <div class="row innerPage">
            <div class="col-sm-6">
              <fccInput extraClasses="inputLabel" required v-model="isencao.titulo"
                >Título<span>*</span></fccInput
              >
            </div>
            <div class="col-sm-3 fccSirsdate">
              <fccDateInput
                id="dtFinalDisponivel"
                type="datetime"
                class="form-control"
                v-model="isencao.dsdtfinalinscricao"
                :min-datetime="capturaDataAtualSGP()"
                required
              >
                Data final da isenção
              </fccDateInput>
            </div>
            <div class="col-sm-3 fccSirsdate">
              <fccDateInput
                id="dtFinalInscricao"
                type="datetime"
                class="form-control"
                v-model="isencao.dtfinaldisponivel"
                :min-datetime="capturaDataAtualSGP()"
                required
              >
                Data final da isenção
              </fccDateInput>
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-4">
              <span
                ><toggle-button v-model="isencao.validaenviaarquivo" :sync="true" /> Arquivo
                obrigatório</span
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-4">
              <fcc-select
                label-field="descricao"
                value-field="id"
                v-model="isencao.situacao"
                :clearable="false"
                :options="listagemSituacaoSir"
                required
                >Situação</fcc-select
              >
            </div>
            <div class="col-sm-4">
              <fcc-select
                label-field="descricao"
                value-field="id"
                :clearable="false"
                v-model="isencao.tpenvio"
                :options="listagemTipoEnvioSir2Monit"
                required
                >Tipo envio doc.</fcc-select
              >
            </div>
            <div class="col-sm-4">
              <fcc-select
                label-field="descricao"
                value-field="id"
                :clearable="false"
                v-model="isencao.tpsir"
                :options="listagemTipoSir2Monit"
                required
                >Tipo</fcc-select
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-4 titlePage">Instruções</div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <fccEditor class="mb-2" v-model="isencao.instrucao" />
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-4 titlePage">Termos de aceite</div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-10">
              <textarea class="inputLabel" v-model="opcao"></textarea>
            </div>
            <div class="col-sm-2">
              <fccButton tipo="button" @click="addConcordo">
                <font-awesome-icon icon="plus" />
              </fccButton>
            </div>
          </div>
          <fccTable
            modal
            class="innerPage"
            striped
            hover
            :fields="fieldsOptions"
            :orderby="sortBy"
            :actions="actionsOptions"
            :items="listaConcordo"
            responsive
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
          <template>
            <div class="row innerPage">
              <div class="col-sm-4 titlePage">Subtipos</div>
            </div>
            <div class="row innerPage">
              <div class="col-sm-8">
                <fcc-select
                  label-field="descricao"
                  :clearable="false"
                  v-model="subtipo"
                  :options="listSub"
                  >Subtipo</fcc-select
                >
              </div>
              <div class="col-sm-3 mt-1" v-if="subtipo">
                <span><toggle-button v-model="exibir" :sync="true" /> Exibir candidato</span>
              </div>
              <div class="col-sm-1">
                <fccButton tipo="button" @click="addSub">
                  <font-awesome-icon icon="plus" />
                </fccButton>
              </div>
            </div>
            <fccTable
              modal
              class="innerPage"
              striped
              hover
              :fields="fieldsSub"
              :orderby="sortBy"
              :actions="actionsSub"
              :items="listaSubtipo"
              responsive
              :titlePage="titlePage"
              :titlePDF="titlePDF"
            ></fccTable>
          </template>
          <div class="row my-3 buttonSalvar">
            <div class="col-sm-12 text-right">
              <fccButton tipo="submit">
                <font-awesome-icon icon="save" /> {{ labelsSystem.salvar }}</fccButton
              >
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import Vue from 'vue'
import store from '@/store'
import axios from 'axios'

import Sirs from '../fccSirs/mixim/sirs'
Vue.mixin(Sirs)

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Isenção e Redução',
      titlePDF: 'Isenção e Redução',
      exibir: true,
      titleModal: '',
      fields: [
        { key: 'idsir', label: 'Id', sortable: false },
        { key: 'descricaotipo', label: 'Tipo', sortable: true },
        { key: 'titulo', label: 'Título', sortable: true },
        { key: 'actions', label: '' }
      ],
      fieldsSub: [
        { key: 'id', label: 'Id', sortable: false },
        { key: 'idsubtipo', label: 'Id SubTipo', sortable: false },
        { key: 'descricao', label: 'Tipo', sortable: true },
        {
          key: 'exibir',
          label: 'Exibir candidato',
          active: true,
          tdClass: 'no-print',
          thClass: 'no-print',
          type: 'toggle',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        { key: 'actions', label: '' }
      ],
      fieldsOptions: [
        { key: 'descricao', label: 'Opção', sortable: true },
        { key: 'actions', label: '' }
      ],
      itemPorPage: '100',
      situacao: {},

      actionsOptions: [
        {
          button: true,
          funcaoButton: 'deleteOptions',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      optionsButton: [
        {
          funcaoButton: 'adicionarField',
          tooltip: 'Adicionar',
          icon: 'plus',
          text: 'Adicionar',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        {
          funcaoButton: 'adicionarReabertura',
          tooltip: 'Adicionar Reabertura',
          icon: 'plus',
          text: 'Adicionar Reabertura',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ],
      actionsSub: [
        {
          button: true,
          funcaoButton: 'deleteSub',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editIsencao',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteIsencao',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      liberaPublicacao: '1',
      textoPublicacao: 'SIR',
      tipoPublicacao: '',
      baseUrlPublicacao: '',
      baseUrlGestaoProjetos: '',
      lstIsencao: [],
      listSub: [],
      listaSubtipo: [],
      listaConcordo: [],
      instrucao: '',
      isencao: {},
      subtipo: '',
      opcao: ''
    }
  },
  methods: {
    addConcordo() {
      if (this.opcao != '') {
        const opcao = {
          id: 0,
          descricao: this.opcao
        }
        this.listaConcordo.push(opcao)
        this.opcao = ''
      }
    },
    addSub() {
      if (this.subtipo != '') {
        this.subtipo.idsubtipo = this.subtipo.id
        this.subtipo.exibir = this.exibir
        this.subtipo.id = 0
        this.subtipo.cdfuncionario = this.dadosUserSession.usuCdFuncionario
        this.listaSubtipo.push(this.subtipo)
        this.listarSubTipoSir2Monit().then((response) => {
          this.listSub = this.filtraArray(response, this.listaSubtipo)
          this.subtipo = ''
          this.carregaTexto()
        })
      }
    },
    deleteOptions(_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.listaConcordo = this.arrayRemove(this.listaConcordo, item)
          this.opcao = ''
        }
      })
    },
    deleteSub(_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          this.listaSubtipo = this.arrayRemove(this.listaSubtipo, item)
          this.listaSubMonit()
        }
      })
    },
    listaSubMonit() {
      this.listarSubTipoSir2Monit().then((response) => {
        this.listSub = this.filtraArray(response, this.listaSubtipo)
        this.carregaTexto()
      })
    },
    adicionarReabertura() {
      this.addField(true)
    },
    adicionarField() {
      this.addField(false)
    },
    addField(status = false) {
      this.buscaInstituicaoConcurso()
      this.isencao = {}
      this.listaConcordo = []
      this.listaSubtipo = []
      this.isencao.idsir = 0
      this.isencao.reaberturaIsencao = status
      this.listaSubMonit()
      this.titleModal = 'Adicionar Isenção'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    filtraArray(array, array2) {
      return array.filter((item) => !array2.some((elem) => item.descricao === elem.descricao))
    },
    editIsencao(_, item) {
      this.isencao = { ...item }
      this.listaConcordo = item.concordo
      this.listaSubtipo = item.listasubtipo
      this.listaSubMonit()
      this.titleModal = 'Editar Isenção'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    deleteIsencao(_, item) {
      this.callConfirm(this.mensagemExcluir, '').then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSir2 + 'Sir2Monit/Excluir/idSir:int?idSir=' + item.idsir,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.lstIsencaoReducao(this.idPublicacao)
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    buscaInstituicaoConcurso: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      if (this.controlePage.spi) {
        axios
          .get(
            this.baseUrlGestaoProjetos +
              'Spi/ListarInstituicaoConcursoPorSpi/' +
              this.controlePage.spi,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            if (response.status === 200) {
              this.isencao.concurso = response.data.concurso
              this.isencao.instituicao = response.data.instituicao
              this.$forceUpdate()
            }
          })
          .catch(this.setErrorSystem)
          .finally(this.carregaTexto)
      }
    },
    addIsencaoReducao() {
      this.isencao.spi = this.controlePage.spi
      this.isencao.idpublicacao = this.controlePage.idpublicacao
      this.isencao.listasubtipo = this.listaSubtipo
      this.isencao.concordo = this.listaConcordo
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlSir2 + 'Sir2Monit/Adicionar',
          this.isencao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.lstIsencaoReducao(this.idPublicacao)
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
        })
        .catch((error) => {
          this.callAlert(error.response.data, '', 'error', 'error')
        })
        .finally(this.carregaTexto)
    },
    editIsencaoReducao() {
      this.isencao.spi = this.controlePage.spi
      this.isencao.idpublicacao = this.controlePage.idpublicacao
      this.isencao.listasubtipo = this.listaSubtipo
      this.isencao.concordo = this.listaConcordo
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlSir2 + 'Sir2Monit/Alterar',
          this.isencao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.lstIsencaoReducao(this.idPublicacao)
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
        })
        .catch((error) => {
          this.callAlert(error.response.data, '', 'error', 'error')
        })
        .finally(this.carregaTexto)
    },
    lstIsencaoReducao(idPublicacao) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSir2 + 'Sir2Monit/Listar/' + idPublicacao + '/false',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstIsencao = response.data
          this.buscaInstituicaoConcurso()
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    idPublicacao: Number,
    controlePage: Object
  },
  mounted: function () {
    this.tipoPublicacao = this.controlePage.idpublictipo
    this.baseUrlPublicacao = store.state.spiPublicacao
    this.baseUrlGestaoProjetos = store.state.baseUrlGestaoProjetos
    this.lstIsencaoReducao(this.idPublicacao)
    this.listarTipoSir2Monit()
    this.listarSubTipoSir2Monit()
    this.listarTipoEnvioSir2Monit()
    this.listarSituacaoSir()
  }
}
</script>